// extracted by mini-css-extract-plugin
export default {"textBlock":"styles_textBlock__5bIAF"};